import React from "react";
import { Link } from "react-router-dom";
import Container from "../../components/Container";
import CustomInput from "../../components/CustomInput";
import logo from "../../assets/images/logo.png";
import { IoArrowForwardOutline } from "react-icons/io5";
import Button from "../../components/Button";
import { BsArrowLeft } from "react-icons/bs";

const EnterCode = () => {
  return (
    <section>
      <Container maxWidth={"max-w-3xl"}>
        <div className="header my-6">
          <div className="flex justify-between items-center">
            <div className="logo w-28">
              <Link to={"/everyone"}>
                <img src={logo} alt="" />
              </Link>
            </div>
            <div className="sign-in">
              <Link to={"/everyone"} className="flex items-center gap-3 p-3">
                <span>Sign In</span>
                <span>
                  <IoArrowForwardOutline />
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className="bg-white xs:p-4 md:p-10 border rounded-lg">
          <div className="text-lg font-semibold mb-6">
            <p className="">Write the code that has been sent to your email</p>
          </div>
          <div className="form my-3">
            <form action="">
              <div className="email flex mb-4 items-center gap-x-3">
                <div className="go-back text-4xl">
                  <Link to="/reset-password/email-confirmation">
                    <BsArrowLeft className="py-1 px-2 transition-all transition-duration-300 hover:bg-gray-100 rounded-full" />
                  </Link>
                </div>
                <div className="confirmed-email py-2 px-4 border rounded-full text-gray-500 flex-auto">
                  <span>example@example.com</span>
                </div>
              </div>
              <div className="code mb-4">
                <CustomInput
                  label={"Confirmation Code"}
                  placeholder="Type confirmation code"
                  name="number"
                  type="number"
                  className="w-full mb-4"
                />
              </div>
              <div className="continue mb-4">
                <Link to="/reset-password/set-password">
                  <Button width={"w-full"}>Continue</Button>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default EnterCode;
